import React from "react";
import { useRef, useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Paper,
  Button,
  ButtonGroup,
  IconButton
} from "@mui/material";
import { Helmet } from "react-helmet";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CalendarPicker } from "@mui/x-date-pickers/CalendarPicker";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from 'moment-timezone';
import dayjs from "dayjs";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { apiUrl } from '../constants'
import axios from 'axios'
import useCheckToken from '../hooks/useCheckToken';
import useExchangeToken from "../hooks/useExchangeToken";
import { useSelector } from 'react-redux';

const inputStyle = {
  "& .MuiOutlinedInput-root": {
    height: 40,
  },
  "& .MuiOutlinedInput-input": {
    padding: "10px 14px",
    fontSize: 16,
  },
};

const line_detail = [
  {
    value: "Line7",
    label: "Line7"
  },
  {
    value: "Line8",
    label: "Line8"
  },
  {
    value: "Line9",
    label: "Line9"
  },
  {
    value: "Line10",
    label: "Line10"
  },
]

const shift_detail = [
  {
    value: "DAY",
    label: "DAY"
  },
  {
    value: "NIGHT",
    label: "NIGHT"
  },
]

const plant_downtime = [
  {
    process: "DOWNTIME",
    value: "SETUP_ADJUST",
    label: "SETUP & ADJUST",
    category: "PLANNED",
    type: "SETUP_ADJUST",
  },
  {
    process: "DOWNTIME",
    value: "CHANGE_PRODUCT",
    label: "CHANGE PRODUCT",
    category: "PLANNED",
    type: "CHANGE_PRODUCT",
  },
  {
    process: "DOWNTIME",
    value: "CHANGEOVER",
    label: "CHANGEOVER",
    category: "PLANNED",
    type: "CHANGEOVER",
  },
  {
    process: "SKU",
    value: "PRODUCTION",
    label: "PRODUCTION",
    category: "PLANNED",
    type: "PRODUCTION",
  },
  {
    process: "DOWNTIME",
    value: "PLANNED_MAINTENANCE",
    label: "PLANNED MAINTENANCE",
    category: "PLANNED",
    type: "PLANNED_MAINTENANCE",
  },
  {
    process: "DOWNTIME",
    value: "NO_PRODUCTION",
    label: "NO PRODUCTION",
    category: "PLANNED",
    type: "NO_PRODUCTION",
  },
  {
    process: "DOWNTIME",
    value: "CLEANING",
    label: "CLEANING",
    category: "PLANNED",
    type: "CLEANING",
  },
];
plant_downtime.sort((a, b) => a.label.localeCompare(b.label));

export default function MESCalendar() {
  const exchangeToken = useExchangeToken();
  const [isTokenExchanged, setIsTokenExchanged] = useState(false);
  const [error, setError] = useState(null);
  const today = new Date();
  const hourago = new Date(today.getTime());
  const calendarRef = useRef(null);
  const [view, setView] = useState("dayGridMonth");
  const [currentDate, setCurrentDate] = useState(dayjs());
  const [selectedDate, setSelectedDate] = useState(moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DD'));
  const [openPopupNewEvent, setOpenPopupNewEvent] = useState(false);
  const [openSelectLine, setOpenSelectLine] = useState(false);
  const [selectedLine, setSelectedLine] = useState('Line7');
  const [selectedShift, setSelectedShift] = useState('');
  const [leftSelectedShift, setLeftSelectedShift] = useState("DAY");
  const [selectedPlantDowntime, setSelectedPlantDowntime] = useState(null);
  const [scheduleDate, setScheduleDate] = useState(moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DD'));
  const [startTime, setStartTime] = useState(moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DDTHH:mm'));
  const [endTime, setEndTime] = useState(moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DDTHH:mm'));
  const [productionStart, setProductionStart] = useState(moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DDTHH:mm'));
  const [productionEnd, setProductionEnd] = useState(moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DDTHH:mm'));
  const [isFirstEvent, setIsFirstEvent] = useState(true);
  const [getSchedulePlantDowntime, setGetSchedulePlantDowntime] = useState([]);
  const [sku, setSku] = useState("");
  const [repeatType, setRepeatType] = useState("NONE");
  const [repeatEndDate, setRepeatEndDate] = useState(
    moment(hourago).tz("Asia/Bangkok").format("YYYY-MM-DD")
  );
  const [openEditEvent, setOpenEditEvent] = useState(false);
  const [selectedEventData, setSelectedEventData] = useState(null);
  const [leftProductionStart, setLeftProductionStart] = useState("");
  const [leftProductionEnd, setLeftProductionEnd] = useState("");
  const [savingProductionPlan, setSavingProductionPlan] = useState(false);
  const [savingEvent, setSavingEvent] = useState(false);
  const [leftProductionErrors, setLeftProductionErrors] = useState({
    productionStart: "",
    productionEnd: "",
  });
  const [errors, setErrors] = useState({
    scheduleDate: "",
    startTime: "",
    endTime: "",
    selectedShift: "",
    selectedPlantDowntime: "",
    productionStart: "",
    productionEnd: "",
    sku: "",
  });

  useCheckToken();
  const ac_token = useSelector(state => state.auth.access_token);
  const display = useSelector(state => state.auth.email);

  useEffect(() => {
    const fetchInitialTokenAndData = async () => {
      try {
        const token = await exchangeToken();
        if (token) {
          setIsTokenExchanged(true);
        }
      } catch (err) {
        console.error("Error exchanging token:", err);
        setError("Failed to exchange token");
      }
    };
    fetchInitialTokenAndData();
  }, [exchangeToken]);

  const handleOpenPopupNewEvent = () => {
    openNewEventByDate(selectedDate);
  };
  const handleClosePopupNewEvent = () => {
    setOpenPopupNewEvent(false);
  };
  const handleCloseSelectLine = () => {
    setOpenSelectLine(false);
  };
  const handleOpenSelectLine = () => {
    setOpenSelectLine(true);
  };
  const handleChangeView = (newView) => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.changeView(newView);

    if (newView === "dayGridMonth" || newView === "timeGridDay") {
      const today = moment().tz("Asia/Bangkok").format("YYYY-MM-DD");
      calendarApi.gotoDate(today);
      setSelectedDate(today);
    }
    setView(newView);
  };

  const handlePrev = () => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.prev();
    const newDate = dayjs(calendarApi.getDate());
    setCurrentDate(newDate);
  };

  const handleNext = () => {
    const calendarApi = calendarRef.current.getApi();
    calendarApi.next();
    const newDate = dayjs(calendarApi.getDate());
    setCurrentDate(newDate);
  };

  const handleEditionLine = (event) => {
    const value = event.target.value;
    setSelectedLine(value)
  };

  const handleEditionShift = (event) => {
    const value = event.target.value;
    setSelectedShift(value);

    const defaults = getDefaultDateTimeByShift(scheduleDate, value);
    setProductionStart(defaults.productionStart);
    setProductionEnd(defaults.productionEnd);
    setStartTime(defaults.startTime);
    setEndTime(defaults.endTime);

    setErrors((previous) => ({
      ...previous,
      selectedShift: "",
      productionStart: "",
      productionEnd: "",
      startTime: "",
      endTime: "",
    }));
  };

  const handleEditionPlantDowntime = (event) => {
    const selected = plant_downtime.find(
      (item) => item.value === event.target.value
    );
    setSelectedPlantDowntime(selected);
  };

  const handleAddSKUName = (event) => {
    const value = event.target.value;
    setSku(value);
  };

  const getDefaultShiftByDate = (dateValue) => {
    const targetDate = moment(dateValue).format("YYYY-MM-DD");

    const hasDay = getSchedulePlantDowntime?.some(
      (item) =>
        item.line === selectedLine &&
        item.shift === "D" &&
        moment(item.factory_date).format("YYYY-MM-DD") === targetDate
    );

    if (hasDay) return "DAY";

    const hasNight = getSchedulePlantDowntime?.some(
      (item) =>
        item.line === selectedLine &&
        item.shift === "N" &&
        moment(item.factory_date).format("YYYY-MM-DD") === targetDate
    );

    if (hasNight) return "NIGHT";

    return "DAY";
  };

  const handleCalendarDateClick = (arg) => {
    const formatted = moment(arg.date)
      .tz("Asia/Bangkok")
      .format("YYYY-MM-DD");

    setSelectedDate(formatted);
    setLeftSelectedShift(getDefaultShiftByDate(formatted));

    // double click = new event
    if (arg.jsEvent?.detail === 2) {
      openNewEventByDate(formatted);
    }
  };

  const fetchMyAPI = async () => {
    if (!ac_token) return [];

    try {
      const response = await axios.get(`${apiUrl.GET_PLANT_DOWNTIME}`, {
        headers: {
          Authorization: `Bearer ${ac_token}`,
        },
      });

      if (response.status === 200) {
        setGetSchedulePlantDowntime(response.data);
        return response.data;
      }

      return [];
    } catch (err) {
      console.error("Error fetching Schedule Plant Downtime:", err);
      return [];
    }
  };

  useEffect(() => {
    if (isTokenExchanged && ac_token) {
      fetchMyAPI();
    }
  }, [isTokenExchanged, ac_token]);

  const getShiftCode = (shiftValue) => {
    return shiftValue === "DAY" ? "D" : "N";
  };

  const MAX_PRODUCTION_HOURS = 48;

  const getShiftBoundary = (dateValue, shiftValue) => {
    const factoryDate = moment(dateValue).format("YYYY-MM-DD");

    if (shiftValue === "NIGHT") {
      return {
        start: moment.tz(`${factoryDate}T18:00`, "Asia/Bangkok"),
        end: moment.tz(`${factoryDate}T18:00`, "Asia/Bangkok").add(12, "hours"),
      };
    }

    return {
      start: moment.tz(`${factoryDate}T06:00`, "Asia/Bangkok"),
      end: moment.tz(`${factoryDate}T18:00`, "Asia/Bangkok"),
    };
  };

  const getDefaultDateTimeByShift = (dateValue, shiftValue = "DAY") => {
    const boundary = getShiftBoundary(dateValue, shiftValue);

    return {
      scheduleDate: moment(dateValue).format("YYYY-MM-DD"),
      productionStart: boundary.start.format("YYYY-MM-DDTHH:mm"),
      productionEnd: boundary.end.format("YYYY-MM-DDTHH:mm"),
      startTime: boundary.start.clone().format("YYYY-MM-DDTHH:mm"),
      endTime: boundary.start.clone().add(1, "hour").format("YYYY-MM-DDTHH:mm"),
    };
  };

  const buildDateTimePreserveDayOffset = ({
    repeatDate,
    originalDateTime,
    originalFactoryDate = scheduleDate,
  }) => {
    const sourceDateTime = moment(originalDateTime);

    if (!sourceDateTime.isValid()) return null;

    const sourceFactoryDate = moment(originalFactoryDate).startOf("day");
    const sourceDate = sourceDateTime.clone().startOf("day");
    const dayOffset = sourceDate.diff(sourceFactoryDate, "days");

    return moment(repeatDate)
      .startOf("day")
      .add(dayOffset, "days")
      .hour(sourceDateTime.hour())
      .minute(sourceDateTime.minute())
      .second(0)
      .millisecond(0)
      .tz("Asia/Bangkok", true)
      .format();
  };

  const getProductionWindowFromPlan = (plan) => {
    if (!plan?.production_start || !plan?.production_end) {
      return null;
    }

    const start = moment(plan.production_start);
    const end = moment(plan.production_end);

    if (!start.isValid() || !end.isValid()) {
      return null;
    }

    return { start, end };
  };

  const validateProductionWindow = ({
    plans = getSchedulePlantDowntime,
    lineValue,
    productionStartValue,
    productionEndValue,
    editingPlanId = null,
  }) => {
    const result = {
      valid: true,
      productionStart: "",
      productionEnd: "",
    };

    const newStart = moment(productionStartValue);
    const newEnd = moment(productionEndValue);

    if (!newStart.isValid()) {
      result.valid = false;
      result.productionStart = "Invalid production start";
    }

    if (!newEnd.isValid()) {
      result.valid = false;
      result.productionEnd = "Invalid production end";
    }

    if (!result.valid) return result;

    if (newEnd.isSameOrBefore(newStart)) {
      result.valid = false;
      result.productionEnd = "Production end must be after production start";
      return result;
    }

    const durationMinutes = newEnd.diff(newStart, "minutes");

    if (durationMinutes > MAX_PRODUCTION_HOURS * 60) {
      result.valid = false;
      result.productionEnd = "Production period must not exceed 48 hours";
      return result;
    }

    // DAY และ NIGHT ใช้สำหรับระบุชื่อกะเท่านั้น
    // ไม่บังคับ Production Start/End ให้อยู่ในช่วง 06:00-18:00
    // หรือ 18:00-06:00 อีกต่อไป โดยยังคงตรวจสอบด้านล่างว่า
    // ช่วงเวลาห้ามซ้อนกับ Production Plan อื่นใน Line เดียวกัน

    const overlappingPlan = plans
      ?.filter((item) => item.line === lineValue)
      ?.find((item) => {
        if (
          editingPlanId &&
          String(item.id) === String(editingPlanId)
        ) {
          return false;
        }

        if (!item.production_start || !item.production_end) {
          return false;
        }

        const oldStart = moment(item.production_start);
        const oldEnd = moment(item.production_end);

        if (!oldStart.isValid() || !oldEnd.isValid()) {
          return false;
        }

        return newStart.isBefore(oldEnd) && newEnd.isAfter(oldStart);
      });

    if (overlappingPlan) {
      const overlapShift = overlappingPlan.shift === "D" ? "DAY" : "NIGHT";

      result.valid = false;
      result.productionStart =
        `Production time overlaps ${overlapShift} shift`;
      result.productionEnd =
        `Production time overlaps ${overlapShift} shift`;
    }

    return result;
  };

  const validateEventInsideProductionWindow = ({
    eventStartValue,
    eventEndValue,
    productionStartValue,
    productionEndValue,
  }) => {
    const eventStartMoment = moment(eventStartValue);
    const eventEndMoment = moment(eventEndValue);
    const productionStartMoment = moment(productionStartValue);
    const productionEndMoment = moment(productionEndValue);

    if (
      !eventStartMoment.isValid() ||
      !eventEndMoment.isValid() ||
      !productionStartMoment.isValid() ||
      !productionEndMoment.isValid()
    ) {
      return {
        valid: false,
        message: "Invalid event or production time",
      };
    }

    const insideWindow =
      eventStartMoment.isSameOrAfter(productionStartMoment) &&
      eventEndMoment.isSameOrBefore(productionEndMoment);

    if (!insideWindow) {
      return {
        valid: false,
        message:
          `Event must be inside production time ` +
          `${productionStartMoment.format("YYYY-MM-DD HH:mm")} - ` +
          `${productionEndMoment.format("YYYY-MM-DD HH:mm")}`,
      };
    }

    return { valid: true, message: "" };
  };

  const getTargetPlanForEvent = ({
    plans = getSchedulePlantDowntime,
    lineValue,
    factoryDate,
    shiftValue,
  }) => {
    return plans?.find(
      (item) =>
        item.line === lineValue &&
        item.shift === getShiftCode(shiftValue) &&
        moment(item.factory_date).format("YYYY-MM-DD") ===
          moment(factoryDate).format("YYYY-MM-DD")
    );
  };


  const buildDateTimeByDate = (dateValue, shiftValue = "DAY") => {
    return getDefaultDateTimeByShift(dateValue, shiftValue);
  };

  const openNewEventByDate = (dateValue) => {
    const defaultDateTime = buildDateTimeByDate(dateValue);

    setSelectedDate(defaultDateTime.scheduleDate);
    setScheduleDate(defaultDateTime.scheduleDate);
    setStartTime(defaultDateTime.startTime);
    setEndTime(defaultDateTime.endTime);
    setProductionStart(defaultDateTime.productionStart);
    setProductionEnd(defaultDateTime.productionEnd);

    setSelectedShift("");
    setSelectedPlantDowntime(null);
    setSku("");
    setRepeatType("NONE");
    setRepeatEndDate(defaultDateTime.scheduleDate);
    setErrors({});
    setSelectedEventData(null);
    setOpenPopupNewEvent(true);
  };

  const findPlanByLineDateShift = ({ lineValue, dateValue, shiftValue }) => {
    return getSchedulePlantDowntime?.find(
      (item) =>
        item.line === lineValue &&
        moment(item.factory_date).format("YYYY-MM-DD") ===
        moment(dateValue).format("YYYY-MM-DD") &&
        item.shift === getShiftCode(shiftValue)
    );
  };

  useEffect(() => {
    // ระหว่าง Save ห้ามเปลี่ยน isFirstEvent เพราะ Plan ใหม่จะถูก fetch กลับมา
    // และทำให้ช่อง Production Start/End หายก่อน Dialog ปิด
    if (savingEvent) return;

    if (!selectedShift) {
      setIsFirstEvent(false);
      return;
    }

    const exists = findPlanByLineDateShift({
      lineValue: selectedLine,
      dateValue: scheduleDate,
      shiftValue: selectedShift,
    });

    setIsFirstEvent(!exists);
  }, [
    scheduleDate,
    selectedLine,
    selectedShift,
    getSchedulePlantDowntime,
    savingEvent,
  ]);

  // useEffect(() => {
  //   const now = moment().tz("Asia/Bangkok");
  //   setStartTime(now.format("YYYY-MM-DDTHH:mm"));
  //   setEndTime(now.format("YYYY-MM-DDTHH:mm"));
  //   setProductionStart(now.format("YYYY-MM-DDTHH:mm"));
  //   setProductionEnd(now.format("YYYY-MM-DDTHH:mm"));
  // }, [scheduleDate]);

  const getEventColor = (type) => {
    switch (type) {
      case "PRODUCTION":
        return "#A5D6A7";
      case "SETUP_ADJUST":
        return "#FFF3B0";
      case "CHANGE_PRODUCT":
        return "#B3E5FC";
      case "CHANGEOVER":
        return "#E1BEE7";
      case "CLEANING":
        return "#B2EBF2";
      case "PLANNED_MAINTENANCE":
        return "#FFCCBC";
      case "NO_PRODUCTION":
        return "#CFD8DC";
      default:
        return "#E0E0E0";
    }
  };

  const calendarEvents = getSchedulePlantDowntime
    ?.filter(item => item.line === selectedLine)
    ?.flatMap(item =>
      item.downtimes.map(dt => ({
        id: dt.id,
        planId: item.id,
        factory_date: item.factory_date,
        shift: item.shift,
        downtime_type: dt.downtime_type,
        status_reason: dt.status_reason,

        title: dt.downtime_type === "" ? `PRODUCTION (${dt.status_reason}) ${item.line}` : `${dt.downtime_type} ${item.line}`,
        start: dt.start_time,
        end: dt.end_time,

        backgroundColor: getEventColor(dt.downtime_type === "" ? "PRODUCTION" : dt.downtime_type),
        borderColor: getEventColor(dt.downtime_type === "" ? "PRODUCTION" : dt.downtime_type),
      }))
    )
    .sort((a, b) => moment(b.start).diff(moment(a.start)));

  const leftEvents = getSchedulePlantDowntime
    ?.filter(item => item.line === selectedLine)
    ?.flatMap(item =>
      item.downtimes.filter(dt => {
        const start = moment(dt.start_time);
        const end = moment(dt.end_time);

        const selectedStart = moment(selectedDate).startOf("day");
        const selectedEnd = moment(selectedDate).endOf("day");

        return start.isSameOrBefore(selectedEnd) &&
          end.isSameOrAfter(selectedStart);
      }).map(dt => ({
        id: dt.id,
        title: dt.downtime_type === "" ? `PRODUCTION (${dt.status_reason}) ${item.line}` : `${dt.downtime_type} ${item.line}`,
        start: dt.start_time,
        end: dt.end_time,
        backgroundColor: getEventColor(dt.downtime_type === "" ? "PRODUCTION" : dt.downtime_type),
      }))
    )
    .sort((a, b) => moment(b.start).diff(moment(a.start)));

  const hasTimeOverlap = ({
    lineValue,
    startValue,
    endValue,
    editingEventId = null,
  }) => {
    const newStart = moment(startValue);
    const newEnd = moment(endValue);

    if (!newStart.isValid() || !newEnd.isValid()) return false;

    return getSchedulePlantDowntime
      ?.filter((item) => item.line === lineValue)
      ?.some((item) =>
        item.downtimes?.some((dt) => {
          if (editingEventId && String(dt.id) === String(editingEventId)) {
            return false;
          }

          const oldStart = moment(dt.start_time);
          const oldEnd = moment(dt.end_time);

          if (!oldStart.isValid() || !oldEnd.isValid()) return false;

          return newStart.isBefore(oldEnd) && newEnd.isAfter(oldStart);
        })
      );
  };

  const validateForm = (isEdit = false) => {
    const newErrors = {};

    if (!selectedShift) newErrors.selectedShift = "Required";
    if (!selectedPlantDowntime) newErrors.selectedPlantDowntime = "Required";
    if (!scheduleDate) newErrors.scheduleDate = "Required";
    if (!startTime) newErrors.startTime = "Required";
    if (!endTime) newErrors.endTime = "Required";

    const eventStart = moment(startTime);
    const eventEnd = moment(endTime);

    if (startTime && !eventStart.isValid()) {
      newErrors.startTime = "Invalid start time";
    }

    if (endTime && !eventEnd.isValid()) {
      newErrors.endTime = "Invalid end time";
    }

    if (
      eventStart.isValid() &&
      eventEnd.isValid() &&
      eventEnd.isSameOrBefore(eventStart)
    ) {
      newErrors.endTime = "End time must be after start time";
    }

    let targetPlan = null;
    let productionWindow = null;

    if (selectedShift && scheduleDate) {
      targetPlan = getTargetPlanForEvent({
        lineValue: selectedLine,
        factoryDate: scheduleDate,
        shiftValue: selectedShift,
      });
    }

    if (!isEdit && !targetPlan) {
      if (!productionStart) newErrors.productionStart = "Required";
      if (!productionEnd) newErrors.productionEnd = "Required";

      if (productionStart && productionEnd) {
        const productionValidation = validateProductionWindow({
          lineValue: selectedLine,
          productionStartValue: productionStart,
          productionEndValue: productionEnd,
          shiftValue: selectedShift,
          factoryDate: scheduleDate,
        });

        if (!productionValidation.valid) {
          if (productionValidation.productionStart) {
            newErrors.productionStart =
              productionValidation.productionStart;
          }

          if (productionValidation.productionEnd) {
            newErrors.productionEnd =
              productionValidation.productionEnd;
          }
        } else {
          productionWindow = {
            start: moment(productionStart),
            end: moment(productionEnd),
          };
        }
      }
    }

    if (targetPlan) {
      productionWindow = getProductionWindowFromPlan(targetPlan);

      if (!productionWindow) {
        newErrors.startTime =
          "Selected shift has no valid production time";
        newErrors.endTime =
          "Selected shift has no valid production time";
      }
    }

    if (isEdit && selectedShift && !targetPlan) {
      newErrors.selectedShift =
        "No production plan exists for this date and shift";
    }

    if (
      eventStart.isValid() &&
      eventEnd.isValid() &&
      eventEnd.isAfter(eventStart) &&
      productionWindow
    ) {
      const insideValidation = validateEventInsideProductionWindow({
        eventStartValue: startTime,
        eventEndValue: endTime,
        productionStartValue: productionWindow.start,
        productionEndValue: productionWindow.end,
      });

      if (!insideValidation.valid) {
        newErrors.startTime = insideValidation.message;
        newErrors.endTime = insideValidation.message;
      }
    }

    if (
      eventStart.isValid() &&
      eventEnd.isValid() &&
      eventEnd.isAfter(eventStart)
    ) {
      const overlap = hasTimeOverlap({
        lineValue: selectedLine,
        startValue: startTime,
        endValue: endTime,
        editingEventId: isEdit ? selectedEventData?.id : null,
      });

      if (overlap) {
        newErrors.startTime =
          "This time range overlaps an existing event";
        newErrors.endTime =
          "This time range overlaps an existing event";
      }
    }

    if (repeatType !== "NONE" && !isEdit) {
      if (!repeatEndDate) {
        newErrors.repeatEndDate = "Required";
      } else if (
        moment(repeatEndDate).isBefore(moment(scheduleDate), "day")
      ) {
        newErrors.repeatEndDate =
          "End repeat must be after factory date";
      }
    }

    if (
      selectedPlantDowntime?.value === "PRODUCTION" &&
      !sku.trim()
    ) {
      newErrors.sku = "Required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const generateRepeatDates = () => {
    const dates = [];

    let current = moment(scheduleDate).startOf("day");
    const end = moment(repeatEndDate).startOf("day");

    while (current.isSameOrBefore(end)) {
      dates.push(current.format("YYYY-MM-DD"));

      if (repeatType === "DAILY") {
        current.add(1, "day");
      } else if (repeatType === "WEEKLY") {
        current.add(1, "week");
      } else if (repeatType === "MONTHLY") {
        current.add(1, "month");
      } else {
        break;
      }
    }

    return dates;
  };

  const buildDateTimeWithRepeatDate = (dateValue, dateTimeValue) => {
    return buildDateTimePreserveDayOffset({
      repeatDate: dateValue,
      originalDateTime: dateTimeValue,
      originalFactoryDate: scheduleDate,
    });
  };

  const findPlanByLineDateShiftFromList = ({ plans, lineValue, dateValue, shiftValue }) => {
    return plans?.find(
      (item) =>
        item.line === lineValue &&
        moment(item.factory_date).format("YYYY-MM-DD") ===
        moment(dateValue).format("YYYY-MM-DD") &&
        item.shift === getShiftCode(shiftValue)
    );
  };

  const hasTimeOverlapFromList = ({
    plans,
    lineValue,
    startValue,
    endValue,
  }) => {
    const newStart = moment(startValue);
    const newEnd = moment(endValue);

    if (!newStart.isValid() || !newEnd.isValid()) return false;

    return plans
      ?.filter((item) => item.line === lineValue)
      ?.some((item) =>
        item.downtimes?.some((dt) => {
          const oldStart = moment(dt.start_time);
          const oldEnd = moment(dt.end_time);

          if (!oldStart.isValid() || !oldEnd.isValid()) return false;

          return newStart.isBefore(oldEnd) && newEnd.isAfter(oldStart);
        })
      );
  };


  const resetNewEventForm = () => {
    // ปิด Dialog ก่อน แล้วจึงล้าง State ภายในฟอร์ม
    setOpenPopupNewEvent(false);
    setSelectedShift("");
    setSelectedPlantDowntime(null);
    setSku("");
    setRepeatType("NONE");
    setRepeatEndDate(scheduleDate);
    setErrors({});
    setIsFirstEvent(false);
  };

  const handlePostSchedulePlantDowntime = async () => {
    if (savingEvent) return;
    if (!validateForm(false)) return;
    if (!selectedPlantDowntime) return;

    let didSaveSuccessfully = false;
    const failedDates = [];
    const skippedOverlapDates = [];

    try {
      setSavingEvent(true);

      const repeatDates =
        repeatType === "NONE" ? [scheduleDate] : generateRepeatDates();

      let latestPlans = await fetchMyAPI();

      for (const repeatDate of repeatDates) {
        const startDateTime = buildDateTimeWithRepeatDate(
          repeatDate,
          startTime
        );
        const endDateTime = buildDateTimeWithRepeatDate(
          repeatDate,
          endTime
        );
        const productionStartDateTime = buildDateTimeWithRepeatDate(
          repeatDate,
          productionStart
        );
        const productionEndDateTime = buildDateTimeWithRepeatDate(
          repeatDate,
          productionEnd
        );

        const existingPlan = findPlanByLineDateShiftFromList({
          plans: latestPlans,
          lineValue: selectedLine,
          dateValue: repeatDate,
          shiftValue: selectedShift,
        });

        let targetProductionStart;
        let targetProductionEnd;

        if (existingPlan) {
          targetProductionStart = existingPlan.production_start;
          targetProductionEnd = existingPlan.production_end;

          if (!targetProductionStart || !targetProductionEnd) {
            failedDates.push(`${repeatDate} - production time not found`);
            continue;
          }
        } else {
          targetProductionStart = productionStartDateTime;
          targetProductionEnd = productionEndDateTime;

          const productionValidation = validateProductionWindow({
            plans: latestPlans,
            lineValue: selectedLine,
            productionStartValue: targetProductionStart,
            productionEndValue: targetProductionEnd,
            shiftValue: selectedShift,
            factoryDate: repeatDate,
          });

          if (!productionValidation.valid) {
            failedDates.push(
              `${repeatDate} - ${
                productionValidation.productionEnd ||
                productionValidation.productionStart
              }`
            );
            continue;
          }
        }

        const insideProduction = validateEventInsideProductionWindow({
          eventStartValue: startDateTime,
          eventEndValue: endDateTime,
          productionStartValue: targetProductionStart,
          productionEndValue: targetProductionEnd,
        });

        if (!insideProduction.valid) {
          failedDates.push(`${repeatDate} - ${insideProduction.message}`);
          continue;
        }

        const overlap = hasTimeOverlapFromList({
          plans: latestPlans,
          lineValue: selectedLine,
          startValue: startDateTime,
          endValue: endDateTime,
        });

        if (overlap) {
          skippedOverlapDates.push(repeatDate);
          continue;
        }

        try {
          if (!existingPlan) {
            const payload = {
              country: "THAILAND",
              plant_id: "4117",
              factory: "00000000000000",
              line: selectedLine,
              factory_date: repeatDate,
              shift: selectedShift === "DAY" ? "D" : "N",
              production_start: targetProductionStart,
              production_end: targetProductionEnd,
              created_by: display,
              downtimes: [
                {
                  process_type: selectedPlantDowntime.process,
                  category: selectedPlantDowntime.category,
                  downtime_type:
                    selectedPlantDowntime.value === "PRODUCTION"
                      ? ""
                      : selectedPlantDowntime.type,
                  start_time: startDateTime,
                  end_time: endDateTime,
                  status_reason:
                    selectedPlantDowntime.value === "PRODUCTION"
                      ? sku
                      : selectedPlantDowntime.label,
                },
              ],
            };

            await axios.post(apiUrl.POST_PLANT_DOWNTIME, payload, {
              headers: { Authorization: `Bearer ${ac_token}` },
            });
          } else {
            const payload = {
              plan: existingPlan.id,
              shift: selectedShift === "DAY" ? "D" : "N",
              process_type: selectedPlantDowntime.process,
              category: selectedPlantDowntime.category,
              downtime_type:
                selectedPlantDowntime.value === "PRODUCTION"
                  ? ""
                  : selectedPlantDowntime.type,
              start_time: startDateTime,
              end_time: endDateTime,
              status_reason:
                selectedPlantDowntime.value === "PRODUCTION"
                  ? sku
                  : selectedPlantDowntime.label,
            };

            await axios.post(apiUrl.POST_UPDATE_PLANT_DOWNTIME, payload, {
              headers: { Authorization: `Bearer ${ac_token}` },
            });
          }

          // ถือว่าบันทึกสำเร็จทันทีหลัง axios สำเร็จ
          didSaveSuccessfully = true;

          // ไม่ fetch ระหว่าง Save เพื่อไม่ให้ isFirstEvent เปลี่ยนก่อน Dialog ปิด
          if (!existingPlan) {
            latestPlans = [
              ...(latestPlans || []),
              {
                id: `temporary-${repeatDate}-${selectedShift}`,
                line: selectedLine,
                factory_date: repeatDate,
                shift: getShiftCode(selectedShift),
                production_start: targetProductionStart,
                production_end: targetProductionEnd,
                downtimes: [
                  {
                    id: `temporary-event-${repeatDate}`,
                    start_time: startDateTime,
                    end_time: endDateTime,
                  },
                ],
              },
            ];
          } else {
            latestPlans = latestPlans.map((plan) =>
              String(plan.id) === String(existingPlan.id)
                ? {
                    ...plan,
                    downtimes: [
                      ...(plan.downtimes || []),
                      {
                        id: `temporary-event-${repeatDate}`,
                        start_time: startDateTime,
                        end_time: endDateTime,
                      },
                    ],
                  }
                : plan
            );
          }
        } catch (innerError) {
          console.error(
            `POST REPEAT ERROR DATE ${repeatDate}:`,
            innerError.response?.data || innerError
          );
          failedDates.push(repeatDate);
        }
      }
    } catch (postError) {
      console.error(
        "POST REPEAT ERROR:",
        postError.response?.data || postError
      );
    } finally {
      if (didSaveSuccessfully) {
        // ปิด Dialog ก่อน refresh เพื่อไม่ให้ Production Start/End หายแล้วค้าง
        resetNewEventForm();
      }

      setSavingEvent(false);

      if (didSaveSuccessfully) {
        try {
          await fetchMyAPI();
        } catch (refreshError) {
          console.error("REFRESH AFTER SAVE ERROR:", refreshError);
        }
      }
    }

    if (skippedOverlapDates.length > 0) {
      window.alert(
        `Some repeat dates were skipped because the time overlaps existing events: ${skippedOverlapDates.join(", ")}`
      );
    }

    if (failedDates.length > 0) {
      window.alert(
        `Some repeat dates failed to save:\n${failedDates.join("\n")}`
      );
    }
  };

  useEffect(() => {
    if (!calendarRef.current) return;

    const api = calendarRef.current.getApi();
    const current = moment(api.getDate()).format("YYYY-MM-DD");

    if (current !== selectedDate) {
      api.gotoDate(selectedDate);
    }
  }, [selectedDate]);

  const handleEventClick = (clickInfo) => {
    const event = clickInfo.event;

    const data = {
      id: event.id,
      planId: event.extendedProps.planId,
      factory_date: event.extendedProps.factory_date,
      shift: event.extendedProps.shift,
      downtime_type: event.extendedProps.downtime_type,
      status_reason: event.extendedProps.status_reason,
      start: event.start,
      end: event.end,
    };

    setSelectedEventData(data);
    setScheduleDate(moment(data.factory_date).format("YYYY-MM-DD"));
    setStartTime(moment(data.start).format("YYYY-MM-DDTHH:mm"));
    setEndTime(moment(data.end).format("YYYY-MM-DDTHH:mm"));
    setSelectedShift(data.shift === "D" ? "DAY" : "NIGHT");

    const selectedDT = plant_downtime.find(
      item =>
        item.type === data.downtime_type ||
        (item.value === "PRODUCTION" && data.downtime_type === "")
    );

    setSelectedPlantDowntime(selectedDT);
    setSku(data.downtime_type === "" ? data.status_reason : "");
    setOpenEditEvent(true);
  };

  const handleUpdateEvent = async () => {
    if (!validateForm(true)) return;

    const targetPlan = getTargetPlanForEvent({
      lineValue: selectedLine,
      factoryDate: scheduleDate,
      shiftValue: selectedShift,
    });

    if (!targetPlan?.id) {
      setErrors((previousErrors) => ({
        ...previousErrors,
        selectedShift:
          "No production plan exists for this date and shift",
      }));
      return;
    }

    try {
      const startDateTime = moment(startTime)
        .tz("Asia/Bangkok")
        .format();
      const endDateTime = moment(endTime)
        .tz("Asia/Bangkok")
        .format();

      const payload = {
        plan: targetPlan.id,
        shift: selectedShift === "DAY" ? "D" : "N",
        process_type: selectedPlantDowntime.process,
        category: selectedPlantDowntime.category,
        downtime_type:
          selectedPlantDowntime.value === "PRODUCTION"
            ? ""
            : selectedPlantDowntime.type,
        start_time: startDateTime,
        end_time: endDateTime,
        status_reason:
          selectedPlantDowntime.value === "PRODUCTION"
            ? sku
            : selectedPlantDowntime.label,
      };

      await axios.put(
        `${apiUrl.PUT_PLANT_DOWNTIME_STANDALONE}${selectedEventData.id}/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${ac_token}`,
          },
        }
      );

      await fetchMyAPI();
      setOpenEditEvent(false);
      setSelectedEventData(null);
      setErrors({});
    } catch (updateError) {
      console.error(
        "UPDATE ERROR:",
        updateError.response?.data || updateError
      );
    }
  };

  const selectedDatePlan = getSchedulePlantDowntime?.find((item) => {
    if (!item.id) return false;
    if (item.line !== selectedLine) return false;
    if (item.shift !== getShiftCode(leftSelectedShift)) return false;

    return (
      moment(item.factory_date).format("YYYY-MM-DD") ===
      moment(selectedDate).format("YYYY-MM-DD")
    );
  });

  useEffect(() => {
    if (selectedDatePlan) {
      setLeftProductionStart(
        selectedDatePlan.production_start
          ? moment(selectedDatePlan.production_start).format("YYYY-MM-DDTHH:mm")
          : ""
      );

      setLeftProductionEnd(
        selectedDatePlan.production_end
          ? moment(selectedDatePlan.production_end).format("YYYY-MM-DDTHH:mm")
          : ""
      );
    } else {
      setLeftProductionStart("");
      setLeftProductionEnd("");
    }

    setLeftProductionErrors({
      productionStart: "",
      productionEnd: "",
    });
  }, [selectedDatePlan?.id, leftSelectedShift, selectedLine, selectedDate]);

  const handleLeftProductionStartChange = (value) => {
    if (!value || !value.isValid()) return;

    const planFactoryDate = moment(
      selectedDatePlan?.factory_date || selectedDate
    ).format("YYYY-MM-DD");

    const nextStart = moment(
      `${planFactoryDate}T${value.format("HH:mm")}`
    );

    let nextEnd = leftProductionEnd
      ? moment(leftProductionEnd)
      : null;

    // ช่องด้านซ้ายแสดงเฉพาะ HH:mm จึงตีความ End ที่น้อยกว่าหรือเท่ากับ
    // Start ว่าเป็นเวลาของวันถัดไป เช่น 19:00 -> 05:00
    if (nextEnd?.isValid()) {
      nextEnd = moment(
        `${planFactoryDate}T${nextEnd.format("HH:mm")}`
      );

      if (nextEnd.isSameOrBefore(nextStart)) {
        nextEnd.add(1, "day");
      }

      setLeftProductionEnd(
        nextEnd.format("YYYY-MM-DDTHH:mm")
      );
    }

    setLeftProductionStart(
      nextStart.format("YYYY-MM-DDTHH:mm")
    );

    setLeftProductionErrors({
      productionStart: "",
      productionEnd: "",
    });
  };

  const handleLeftProductionEndChange = (value) => {
    if (!value || !value.isValid()) return;

    const planFactoryDate = moment(
      selectedDatePlan?.factory_date || selectedDate
    ).format("YYYY-MM-DD");

    const currentStart = leftProductionStart
      ? moment(leftProductionStart)
      : moment(`${planFactoryDate}T00:00`);

    let nextEnd = moment(
      `${planFactoryDate}T${value.format("HH:mm")}`
    );

    // หาก End <= Start ให้ถือว่า End อยู่วันถัดไป
    if (nextEnd.isSameOrBefore(currentStart)) {
      nextEnd.add(1, "day");
    }

    setLeftProductionEnd(
      nextEnd.format("YYYY-MM-DDTHH:mm")
    );

    setLeftProductionErrors({
      productionStart: "",
      productionEnd: "",
    });
  };

  const handleUpdateProductionPlan = async () => {
    if (!selectedDatePlan?.id) return;

    const newErrors = {};

    if (!leftProductionStart) {
      newErrors.productionStart = "Required";
    }

    if (!leftProductionEnd) {
      newErrors.productionEnd = "Required";
    }

    if (leftProductionStart && leftProductionEnd) {
      const productionValidation = validateProductionWindow({
        lineValue: selectedDatePlan.line,
        productionStartValue: leftProductionStart,
        productionEndValue: leftProductionEnd,
        editingPlanId: selectedDatePlan.id,
        shiftValue: leftSelectedShift,
        factoryDate: selectedDatePlan.factory_date,
      });

      if (!productionValidation.valid) {
        if (productionValidation.productionStart) {
          newErrors.productionStart =
            productionValidation.productionStart;
        }

        if (productionValidation.productionEnd) {
          newErrors.productionEnd =
            productionValidation.productionEnd;
        }
      }

      if (
        productionValidation.valid &&
        selectedDatePlan.downtimes?.length > 0
      ) {
        const eventOutsideWindow =
          selectedDatePlan.downtimes.find((downtime) => {
            const validation =
              validateEventInsideProductionWindow({
                eventStartValue: downtime.start_time,
                eventEndValue: downtime.end_time,
                productionStartValue: leftProductionStart,
                productionEndValue: leftProductionEnd,
              });

            return !validation.valid;
          });

        if (eventOutsideWindow) {
          const eventStartValue = moment(
            eventOutsideWindow.start_time
          ).format("YYYY-MM-DD HH:mm");
          const eventEndValue = moment(
            eventOutsideWindow.end_time
          ).format("YYYY-MM-DD HH:mm");

          const message =
            `Existing event ${eventStartValue} - ${eventEndValue} ` +
            `is outside the new production time`;

          newErrors.productionStart = message;
          newErrors.productionEnd = message;
        }
      }
    }

    setLeftProductionErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    try {
      setSavingProductionPlan(true);

      const payload = {
        country: "THAILAND",
        plant_id: "4117",
        factory: "00000000000000",
        line: selectedDatePlan.line,
        factory_date: moment(
          selectedDatePlan.factory_date
        ).format("YYYY-MM-DD"),
        shift: selectedDatePlan.shift,
        production_start: moment(leftProductionStart)
          .tz("Asia/Bangkok")
          .format(),
        production_end: moment(leftProductionEnd)
          .tz("Asia/Bangkok")
          .format(),
        created_by: display,
      };

      await axios.put(
        `${apiUrl.PARTIAL_UPDATE_PLAN}${selectedDatePlan.id}/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${ac_token}`,
          },
        }
      );

      await fetchMyAPI();

      setLeftProductionErrors({
        productionStart: "",
        productionEnd: "",
      });
    } catch (updatePlanError) {
      console.error(
        "UPDATE PRODUCTION PLAN ERROR:",
        updatePlanError.response?.data || updatePlanError
      );
    } finally {
      setSavingProductionPlan(false);
    }
  };


  return (
    <>
      <Helmet>
        <title>Schedule Plant Downtime | MES</title>
      </Helmet>
      <Box sx={{ width: "100%", padding: 2, backgroundColor: "#f8f9fa" }}>
        <Grid container spacing={2} p={2}>
          {/* LEFT PANEL */}
          <Grid item xs={3}>
            <Paper sx={{ p: 0, borderRadius: 3 }}>
              {/* Mini Calendar */}
              <Box flex="1 1 100%" ml="0px">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <CalendarPicker
                    value={selectedDate ? dayjs(selectedDate) : null}
                    onChange={(newValue) => {
                      if (!newValue) return;
                      const formatted = moment(newValue.toDate()).tz("Asia/Bangkok").format("YYYY-MM-DD");
                      setSelectedDate(formatted);
                      setLeftSelectedShift(getDefaultShiftByDate(formatted));
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Paper>

            {/* Event */}
            <Paper sx={{ mt: 2, p: 2, borderRadius: 3, flexGrow: 1, overflowY: "auto", height: leftEvents?.length > 4 ? '52%' : '56%' }}>
              <Typography variant="h6">Event</Typography>
              <Typography variant="body2" color="text.secondary">
                {moment(selectedDate).format("dddd, DD MMMM YYYY")}
              </Typography>
              {selectedDatePlan && (
                <Box mt={1} p={1} sx={{ border: "1px solid #eee", borderRadius: 2 }}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Grid container spacing={1} alignItems="center">
                      <Grid item xs={4}>
                        <DateTimePicker
                          inputFormat="HH:mm"
                          label="Production Start"
                          ampm={false}
                          value={leftProductionStart ? dayjs(leftProductionStart) : null}
                          onChange={handleLeftProductionStartChange}
                          onAccept={handleLeftProductionStartChange}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              size="small"
                              error={!!leftProductionErrors.productionStart}
                              helperText={leftProductionErrors.productionStart}
                              sx={{ "& .MuiInputBase-root": { height: 36 } }}
                            />
                          )}
                        />
                      </Grid>

                      <Grid item xs={4}>
                        <DateTimePicker
                          inputFormat="HH:mm"
                          label="Production End"
                          ampm={false}
                          value={leftProductionEnd ? dayjs(leftProductionEnd) : null}
                          onChange={handleLeftProductionEndChange}
                          onAccept={handleLeftProductionEndChange}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              size="small"
                              error={!!leftProductionErrors.productionEnd}
                              helperText={leftProductionErrors.productionEnd}
                              sx={{ "& .MuiInputBase-root": { height: 36 } }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <FormControl fullWidth size="small">
                          <InputLabel>Shift</InputLabel>
                          <Select
                            value={leftSelectedShift}
                            label="Shift"
                            onChange={(e) => setLeftSelectedShift(e.target.value)}
                            sx={{ height: 36 }}
                          >
                            {shift_detail.map((item) => (
                              <MenuItem key={item.value} value={item.value}>
                                {item.value}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={2}>
                        <Button
                          fullWidth
                          variant="contained"
                          size="small"
                          onClick={handleUpdateProductionPlan}
                          disabled={savingProductionPlan || !selectedDatePlan?.id}
                          sx={{ height: 36, minWidth: 0, px: 1 }}
                        >
                          Save
                        </Button>
                      </Grid>

                    </Grid>
                  </LocalizationProvider>
                </Box>
              )}
              {leftEvents?.length > 0 ? (
                leftEvents.map((event) => (
                  <Box
                    key={event.id}
                    sx={{
                      mt: 2,
                      bgcolor: event.backgroundColor,
                      p: 1,
                      borderRadius: 2
                    }}
                  >
                    <Typography variant="body2">
                      {event.title}
                    </Typography>
                    <Typography variant="caption">
                      {moment(event.start).format("HH:mm")} -{" "}
                      {moment(event.end).format("HH:mm")}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography mt={2} color="text.secondary">
                  No events
                </Typography>
              )}
            </Paper>
          </Grid>

          {/* RIGHT PANEL */}
          <Grid item xs={9}>
            {/* Top bar */}
            <Paper
              sx={{
                p: 2,
                mb: 2,
                borderRadius: 3,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <IconButton onClick={handlePrev}>
                  <ChevronLeftIcon />
                </IconButton>
                <Typography variant="h6">
                  {currentDate.format("YYYY MMMM")}
                </Typography>
                <IconButton onClick={handleNext}>
                  <ChevronRightIcon />
                </IconButton>
              </Box>

              <Box display="flex" gap={1}>
                <FormControl size="small">
                  <Select
                    open={openSelectLine}
                    onClose={handleCloseSelectLine}
                    onOpen={handleOpenSelectLine}
                    value={selectedLine || ''}
                    onChange={handleEditionLine}
                    name="line"
                  >
                    {line_detail.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <ButtonGroup>
                  <Button
                    variant={view === "dayGridMonth" ? "contained" : "outlined"}
                    onClick={() => handleChangeView("dayGridMonth")}
                  >
                    Monthly
                  </Button>
                  <Button
                    variant={view === "timeGridWeek" ? "contained" : "outlined"}
                    onClick={() => handleChangeView("timeGridWeek")}
                  >
                    Weekly
                  </Button>
                  <Button
                    variant={view === "timeGridDay" ? "contained" : "outlined"}
                    onClick={() => handleChangeView("timeGridDay")}
                  >
                    Daily
                  </Button>
                  <Button
                    variant={view === "listMonth" ? "contained" : "outlined"}
                    onClick={() => handleChangeView("listMonth")}
                  >
                    List
                  </Button>
                </ButtonGroup>
                <Button
                  variant="outlined"
                  onClick={() => { handleOpenPopupNewEvent(); }}
                >
                  New Event
                </Button>
              </Box>
            </Paper>
            {/* Calendar Grid */}
            <FullCalendar
              ref={calendarRef}
              height="90vh"
              plugins={[
                dayGridPlugin,
                timeGridPlugin,
                interactionPlugin,
                listPlugin,
              ]}
              headerToolbar={false}
              initialView="dayGridMonth"
              editable={false}
              selectable={true}
              selectMirror
              dayMaxEvents
              eventStartEditable={false}
              eventDurationEditable={false}
              eventTextColor="#000000"
              dateClick={handleCalendarDateClick}
              eventClick={handleEventClick}
              events={calendarEvents}
              eventOrder={(a, b) => moment(b.start).diff(moment(a.start))}
            />
          </Grid>
        </Grid>
      </Box>

      <Dialog
        open={openPopupNewEvent}
        onClose={() => {
          if (savingEvent) return;
          handleClosePopupNewEvent();
        }}
        disableEscapeKeyDown={savingEvent}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          New Event
        </DialogTitle>
        <DialogContent>
          <Grid container columnSpacing={2} rowSpacing={2}>
            {/* Plant */}
            <Grid item xs={12} sx={{ mt: 1 }}>
              <TextField
                disabled
                fullWidth
                label="Plant"
                value={4117}
                size="small"
                sx={{
                  ...inputStyle,
                  "& .MuiOutlinedInput-input": { color: "#000", fontSize: 18 },
                }}
              />
            </Grid>
            {/* Factory */}
            <Grid item xs={12}>
              <TextField
                disabled
                fullWidth
                label="Factory"
                value={"FPP2"}
                size="small"
                sx={{
                  ...inputStyle,
                  "& .MuiOutlinedInput-input": { color: "#000", fontSize: 18 },
                }}
              />
            </Grid>
            {/* Line */}
            <Grid item xs={12}>
              <TextField
                disabled
                fullWidth
                label="Line"
                value={selectedLine}
                size="small"
                sx={{
                  ...inputStyle,
                  "& .MuiOutlinedInput-input": { color: "#000", fontSize: 18 },
                }}
              />
            </Grid>
            {/* Date */}
            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  inputFormat="YYYY-MM-DD"
                  value={scheduleDate ? dayjs(scheduleDate) : null}
                  onChange={(newValue) => {
                    if (newValue) {
                      const formatted = moment(newValue.toDate())
                        .tz("Asia/Bangkok")
                        .format("YYYY-MM-DD");

                      const defaultDateTime = buildDateTimeByDate(formatted, selectedShift || "DAY");

                      setScheduleDate(defaultDateTime.scheduleDate);
                      setStartTime(defaultDateTime.startTime);
                      setEndTime(defaultDateTime.endTime);
                      setProductionStart(defaultDateTime.productionStart);
                      setProductionEnd(defaultDateTime.productionEnd);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      error={!!errors.scheduleDate}
                      helperText={errors.scheduleDate}
                      sx={inputStyle}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            {/* Shift */}
            <Grid item xs={6}>
              <FormControl fullWidth size="small" error={!!errors.selectedShift}>
                <InputLabel>Select Shift</InputLabel>
                <Select
                  value={selectedShift || ""}
                  onChange={handleEditionShift}
                  label="Select Shift"
                >
                  {shift_detail.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
                <Typography variant="caption" color="error">
                  {errors.selectedShift}
                </Typography>
              </FormControl>
            </Grid>
            {/* Repeat */}
            {/* Repeat */}
            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Repeat</InputLabel>
                <Select
                  value={repeatType}
                  label="Repeat"
                  onChange={(e) => {
                    const value = e.target.value;
                    setRepeatType(value);

                    if (value === "NONE") {
                      setRepeatEndDate(scheduleDate);
                    }

                    if (value === "DAILY") {
                      setRepeatEndDate(
                        moment(scheduleDate).add(7, "days").format("YYYY-MM-DD")
                      );
                    }

                    if (value === "WEEKLY") {
                      setRepeatEndDate(
                        moment(scheduleDate).add(1, "month").format("YYYY-MM-DD")
                      );
                    }

                    if (value === "MONTHLY") {
                      setRepeatEndDate(
                        moment(scheduleDate).add(6, "months").format("YYYY-MM-DD")
                      );
                    }
                  }}
                >
                  <MenuItem value="NONE">Does not repeat</MenuItem>
                  <MenuItem value="DAILY">Daily</MenuItem>
                  <MenuItem value="WEEKLY">Weekly</MenuItem>
                  <MenuItem value="MONTHLY">Monthly</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* End Repeat */}
            {repeatType !== "NONE" && (
              <Grid item xs={6}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="End repeat"
                    inputFormat="YYYY-MM-DD"
                    value={repeatEndDate ? dayjs(repeatEndDate) : null}
                    minDate={scheduleDate ? dayjs(scheduleDate) : undefined}
                    onChange={(newValue) => {
                      if (newValue) {
                        setRepeatEndDate(newValue.format("YYYY-MM-DD"));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        error={!!errors.repeatEndDate}
                        helperText={errors.repeatEndDate}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
            )}

            {isFirstEvent && (
              <>
                <Grid item xs={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      inputFormat="YYYY-MM-DDTHH:mm"
                      label="Production Start"
                      ampm={false}
                      value={productionStart ? dayjs(productionStart) : null}
                      onChange={(v) => {
                        if (v && v.isValid()) {
                          setProductionStart(v.format("YYYY-MM-DDTHH:mm"));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth size="small"
                          error={!!errors.productionStart}
                          helperText={errors.productionStart}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateTimePicker
                      inputFormat="YYYY-MM-DDTHH:mm"
                      label="Production End"
                      ampm={false}
                      value={productionEnd ? dayjs(productionEnd) : null}
                      onChange={(v) => {
                        if (v && v.isValid()) {
                          setProductionEnd(v.format("YYYY-MM-DDTHH:mm"));
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} fullWidth size="small"
                          error={!!errors.productionEnd}
                          helperText={errors.productionEnd}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>
              </>
            )}
            {/* Start Time */}
            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  inputFormat="YYYY-MM-DDTHH:mm"
                  label="Start time"
                  ampm={false}
                  value={startTime ? dayjs(startTime) : null}
                  onChange={(v) => {
                    if (v && v.isValid()) {
                      setStartTime(v.format("YYYY-MM-DDTHH:mm"));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth size="small"
                      error={!!errors.startTime}
                      helperText={errors.startTime}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            {/* End Time */}
            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  inputFormat="YYYY-MM-DDTHH:mm"
                  label="End time"
                  ampm={false}
                  value={endTime ? dayjs(endTime) : null}
                  onChange={(v) => {
                    if (v && v.isValid()) {
                      setEndTime(v.format("YYYY-MM-DDTHH:mm"));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth size="small"
                      error={!!errors.endTime}
                      helperText={errors.endTime}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth size="small" error={!!errors.selectedPlantDowntime}>
                <InputLabel>Select Plant Downtime</InputLabel>
                <Select
                  value={selectedPlantDowntime?.value || ""}
                  onChange={handleEditionPlantDowntime}
                  label="Select Plant Downtime"
                >
                  {plant_downtime.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
                <Typography variant="caption" color="error">
                  {errors.selectedPlantDowntime}
                </Typography>
              </FormControl>
            </Grid>
            {selectedPlantDowntime?.value === "PRODUCTION" && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="add sku name"
                  size="small"
                  value={sku}
                  onChange={handleAddSKUName}
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            style={{ minWidth: '110px', backgroundColor: '#575755' }}
            variant="contained"
            disabled={savingEvent}
            onClick={handleClosePopupNewEvent}
          >
            Cancel
          </Button>
          <Button
            sx={{
              minWidth: '110px',
              backgroundColor: '#009688',
              "&:hover": { backgroundColor: '#00796B' }
            }}
            variant="contained"
            onClick={handlePostSchedulePlantDowntime}
            disabled={savingEvent}
          >
            {savingEvent ? "Saving..." : "Save"}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Edit event in calendar*/}
      <Dialog
        open={openEditEvent}
        onClose={() => setOpenEditEvent(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Edit Event</DialogTitle>

        <DialogContent>
          <Grid container columnSpacing={2} rowSpacing={2}>

            {/* Plant */}
            <Grid item xs={12} sx={{ mt: 1 }}>
              <TextField
                disabled
                fullWidth
                label="Plant"
                value={4117}
                size="small"
                sx={inputStyle}
              />
            </Grid>

            {/* Factory */}
            <Grid item xs={12}>
              <TextField
                disabled
                fullWidth
                label="Factory"
                value={"FPP2"}
                size="small"
                sx={inputStyle}
              />
            </Grid>

            {/* Line */}
            <Grid item xs={12}>
              <TextField
                disabled
                fullWidth
                label="Line"
                value={selectedLine}
                size="small"
                sx={inputStyle}
              />
            </Grid>

            {/*  Date */}
            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  inputFormat="YYYY-MM-DD"
                  value={scheduleDate ? dayjs(scheduleDate) : null}
                  onChange={(newValue) => {
                    if (newValue) {
                      const formatted = moment(newValue.toDate())
                        .tz("Asia/Bangkok")
                        .format("YYYY-MM-DD");
                      setScheduleDate(formatted);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      inputFormat="YYYY-MM-DD"
                      {...params}
                      fullWidth
                      size="small"
                      error={!!errors.scheduleDate}
                      helperText={errors.scheduleDate}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            {/* Shift */}
            <Grid item xs={6}>
              <FormControl fullWidth size="small" error={!!errors.selectedShift}>
                <InputLabel>Select Shift</InputLabel>
                <Select
                  value={selectedShift || ""}
                  onChange={handleEditionShift}
                  label="Select Shift"
                >
                  {shift_detail.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Start */}
            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  inputFormat="YYYY-MM-DDTHH:mm"
                  label="Start time"
                  ampm={false}
                  value={startTime ? dayjs(startTime) : null}
                  onChange={(v) => {
                    if (v && v.isValid()) {
                      setStartTime(v.format("YYYY-MM-DDTHH:mm"));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth size="small"
                      error={!!errors.startTime}
                      helperText={errors.startTime}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            {/* End */}
            <Grid item xs={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateTimePicker
                  inputFormat="YYYY-MM-DDTHH:mm"
                  label="End time"
                  ampm={false}
                  value={endTime ? dayjs(endTime) : null}
                  onChange={(v) => {
                    if (v && v.isValid()) {
                      setEndTime(v.format("YYYY-MM-DDTHH:mm"));
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} fullWidth size="small"
                      error={!!errors.endTime}
                      helperText={errors.endTime}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            {/* Plant Downtime */}
            <Grid item xs={12}>
              <FormControl
                fullWidth
                size="small"
                error={!!errors.selectedPlantDowntime}
              >
                <InputLabel>Select Plant Downtime</InputLabel>
                <Select
                  value={selectedPlantDowntime?.value || ""}
                  onChange={handleEditionPlantDowntime}
                  label="Select Plant Downtime"
                >
                  {plant_downtime.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
                <Typography variant="caption" color="error">
                  {errors.selectedPlantDowntime}
                </Typography>
              </FormControl>
            </Grid>

            {/*PRODUCTION → SKU */}
            {selectedPlantDowntime?.value === "PRODUCTION" && (
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="SKU"
                  size="small"
                  value={sku}
                  onChange={handleAddSKUName}
                  error={!!errors.sku}
                  helperText={errors.sku}
                />
              </Grid>
            )}

          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditEvent(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleUpdateEvent}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}